import { ChapterModel } from '../../models/chapter.model';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { CameraModel } from 'src/app/engine/models/camera.model';
import { StoryChapterThumbnail } from '../../models/story-chapter-thumbnail.model';
import { ThumbnailConstants } from 'src/app/shared/thumbnail.constants';
import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { BdGraphNodeStateMap } from 'src/lib/graph/graph.model';

export class NextChapter {
  static readonly type = '[Story Chapter] Next Chapter';
  constructor() { }
}

export class PreviousChapter {
  static readonly type = '[Story Chapter] Previous Chapter';
  constructor() { }
}

export class FirstChapter {
  static readonly type = '[Story Chapter] First Chapter';
  constructor() { }
}

export class LastChapter {
  static readonly type = '[Story Chapter] Last Chapter';
  constructor() { }
}

export class SelectChapter {
  static readonly type = '[Story Chapter] Select Chapter';
  constructor(public chapter?: ChapterModel) { }
}

export class SetChapters {
  static readonly type = '[Story Chapter] Set Chapters';
  constructor(public chapters: ChapterModel[]) { }
}

export class SetChapterIds {
  static readonly type = '[Story Chapter] Set Chapters Ids';
  constructor(public chapterIds: string[]) { }
}

export class SetChapter {
  static readonly type = '[Story Chapter] Set Chapter';
  constructor(public chapter: ChapterModel) { }
}

export class SetChapterBackground {
  static readonly type = '[Story Chapter] Set Chapter Background';
  constructor(public chapterId: string, public background: BackgroundModel) { }
}

export class SetAllChaptersBackground {
  static readonly type = '[Story Chapter] Set All Chapters Background';
  constructor(public background: BackgroundModel) { }
}

export class ResetSelectedChapterBackground {
  static readonly type = '[Story Chapter] Reset Selected Chapter Background';
  constructor() { }
}

export class SetSelectedChapterBackground {
  static readonly type = '[Story Chapter] Set Selected Chapter Background';
  constructor(public background: BackgroundModel) { }
}

export class SaveLiveToChapter {
  static readonly type = '[Story Chapter] Save Live Scene State to Chapter';
  constructor(public chapterId?: string) {}
}

export class DuplicateChapter {
  static readonly type = '[Story Chapter] Duplicate An Existing Chapter';
  constructor(public chapter?: ChapterModel, public location?: number) {}
}

export class RemoveChapter {
  static readonly type = '[Story Chapter] Remove Chapter';
  constructor(public chapter: ChapterModel) { }
}

export class ResetStoryChapters {
  static readonly type = '[Story Chapter] Reset';
  constructor() { }
}

export class RecordChapterVisibilityState {
  static readonly type = '[Story Chapters] Record Chapter Visibility State';
  constructor(public nodes: ViewTreeNode[], public visible: boolean, public record: boolean = false) {}
}

export class RecordChapterPickableState {
  static readonly type = '[Story Chapters] Record Chapter Pickable State';
  constructor(public nodes: ViewTreeNode[], public pickable: boolean, public record: boolean = false) {}
}

export class RecordChapterNodeState {
  static readonly type = '[Story Chapters] Record Chapter Node State';
  constructor(public nodes: ViewTreeNode[], public stateMap: BdGraphNodeStateMap, public record: boolean = false) {}
}

export class RecordChapterPaintState {
  static readonly type = '[Story Chapters] Record Chapter Paint State';
  constructor(public nodes: ViewTreeNode[], public paintState: ColorRecipeModel, public record: boolean = false) {}
}

export class RecordShadowChapter {
  static readonly type = '[Story Chapters] Record Shadow Chapter';
  constructor(public chapter: ChapterModel) {}
}

export class RegisterChapterThumbnails {
  static readonly type = '[Story Chapters] Register thumbnail URLs from story';
  constructor(public thumbnails: Map<string, StoryChapterThumbnail>) {}
}

export class RecordChapterCamera {
  static readonly type = '[Story Chapters] Record chapter camera';
  constructor(public camera: CameraModel, public record: boolean) {}
}

export class CopyThumbnail {
  static readonly type = '[Story Chapters] Copy Thumbnail From Chapter';
  constructor(public sourceChapter: ChapterModel, public targetChapter: ChapterModel) {}
}

export class TakeChapterPicture {
  static readonly type = '[Story Chapters] Take picture';
  width: number;
  height: number;
  constructor(public chapterId: string) {
    const size = new ThumbnailConstants().thumbnails.sizes.large;
    this.width = size[0];
    this.height = size[1];
  }
}

export class TakeChapterPictureSuccess {
  static readonly type = '[Story Chapters] Take picture success';
  constructor(public chapterId: string, public blob: Blob) {}
}

